<template>
  <v-badge :color="badgeColor" overlap :value="badgeNumber !== 0">
    <template v-slot:badge>
      <span class="opposite--text">{{ badgeNumber }}</span>
    </template>
    <v-tooltip bottom :disabled="!tooltipText">
      <template v-slot:activator="{ on }">
        <v-icon
          v-bind="$attrs"
          :color="iconColor"
          v-on="on"
          @click="$emit('click', $event)"
        >
          {{ icon }}
        </v-icon>
      </template>
      <div>{{ tooltipText }}</div>
      <div v-for="(item, index) in tooltipArray" :key="index">
        {{ item }}
      </div>
    </v-tooltip>
  </v-badge>
</template>
<script>
export default {
  name: 'DisplayIconBadgeTooltip',
  props: {
    badgeNumber: { type: Number, default: 0 },
    badgeColor: { type: String, default: 'blue-venice' },
    iconColor: { type: String },
    icon: { type: String, required: true },
    tooltipText: { type: String, required: false },
    tooltipArray: { type: Array, required: false },
  },
};
</script>
